import React from "react";
import "./News.css"
import NavBar from "../NavBar/NavBar";
import Footer from "../Footer/Footer";
import news1 from "./images/news1.jpeg";

class News extends React.Component {
    render() {
        return (
            <div>
                <NavBar/>
                <div id="news-page">
                    <h4>Kids in Seats News</h4>
                    <div className="news">
                        <img src={news1} alt="news picture1"/>
                        <div className="news-bar">
                            <p className="news-title">Race Track Chaplaincy Donation</p>
                            <p className="news-date">9/21</p>
                        </div>
                        <p className="news-blurb">
                            Our COO, Rae Anne McLaughlin, received a generous grant from our partner, Race Track Chaplaincy at Belmont. Our work would not be possible without the support from our generous donors!
                        </p>
                    </div>
                    <div className="news">
                        <h2>"Our families come from some of the poorest urban zip codes in the United States and these experiences are often ones that they could never have experienced. 
                            We use all of these experiences as reward for positive change and treatment compliance. 
                            It is a brilliant concept which has proven itself to be successful over and over again."</h2>
                        <div className="news-bar">
                            <p className="news-title">Morris Heights Health Center Testimony</p>
                        </div>
                    </div>
                    <div className="news">
                        <h2>"Jalen and Jamair have reached many goals that before the Kids in Seats Program, they would not have even attempted to 
                            obtain. One being Reading for Rewards Program, which is reading two books to receive two baseball tickets to their first 
                            baseball game ever! The boys were so elated with the experience, they told their Mom, 'We liked our books, can we find a library and go to more games'. 
                            Thank you for helping our kids become passionate in something they now like to do!"</h2>
                        <div className="news-bar">
                            <p className="news-title">The Children's Foundation Testimony</p>
                        </div>
                    </div>
                </div>
                <Footer/>
            </div>
        )
    }
}

export default News;